import { render, staticRenderFns } from "./bings.vue?vue&type=template&id=298046a6&scoped=true&"
import script from "./bings.vue?vue&type=script&lang=js&"
export * from "./bings.vue?vue&type=script&lang=js&"
import style0 from "./bings.vue?vue&type=style&index=0&id=298046a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298046a6",
  null
  
)

export default component.exports